import { render } from "./InvoiceTableDesktop.vue?vue&type=template&id=183dc8f8&scoped=true"
import script from "./InvoiceTableDesktop.vue?vue&type=script&lang=js"
export * from "./InvoiceTableDesktop.vue?vue&type=script&lang=js"

import "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=183dc8f8&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183dc8f8"]])

export default __exports__